export default "__VITE_ASSET__786393e2__"